export default function (state, data) {
    state.buttons.agreements = data.TodayAgrements;
    state.buttons.departureTourists = data.TodayDepartureTurists;
    state.buttons.tourTourists = data.TodayTourTurists;
}